// extracted by mini-css-extract-plugin
module.exports = {"hidden":"companyBtn_hidden__OvF0C","textEmphasis":"companyBtn_textEmphasis__vjlbf","btn":"companyBtn_btn__nN8YT","text":"companyBtn_text__bH1_z"};